import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useApolloClient } from "@apollo/client";
import { toast } from "react-toastify";
import { Input } from "reactstrap";
import { MUTATION_RG_CONTACT_SUPPORT } from "../graphql/mutations";
import {
  ContactSaferGamingWrap,
  StyledLimitWrapper,
} from "../styledComponents/StyledLimits";
import {
  StyledButton,
  StyledFormGroup,
} from "../styledComponents/CommonStyledComponents";
import { StyledMaterialIcon } from "../styledComponents/StyledHeader";

const MAX_MESSAGE_LENGTH = 2000;

const ContactSaferGaming = ({ player, skin }) => {
  const { t } = useTranslation("");
  const apolloClient = useApolloClient();
  const [expanded, setExpanded] = useState(false);
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const trimmedMessage = message.trim();
  const canSubmit = trimmedMessage.length > 0 && !isSubmitting;

  const handleSubmit = async () => {
    if (!canSubmit) return;

    setIsSubmitting(true);

    try {
      const { errors, data } = await apolloClient.mutate({
        mutation: MUTATION_RG_CONTACT_SUPPORT,
        variables: {
          nickName: player.nickName,
          message: trimmedMessage.slice(0, MAX_MESSAGE_LENGTH),
        },
        errorPolicy: "all",
      });

      if (errors) {
        toast.error(t(errors[0].message, errors[0].message), {
          position: "bottom-center",
        });
        return;
      }

      if (data) {
        toast.success(t("label_contact_safer_gaming_success"), {
          position: "bottom-center",
        });
        setMessage("");
        setExpanded(false);
      }
    } catch (error) {
      toast.error(error.message, {
        position: "bottom-center",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ContactSaferGamingWrap>
      <StyledButton
        pub={skin === "pub"}
        btn
        spancol=""
        onClick={() => setExpanded(!expanded)}
      >
        {t("label_contact_safer_gaming")}
        <StyledMaterialIcon as="span" icon={expanded}></StyledMaterialIcon>
      </StyledButton>
      {expanded && (
        <StyledLimitWrapper>
          <StyledFormGroup margin="m-0" col={"col-md-8"}>
            <Input
              type="textarea"
              rows={4}
              maxLength={MAX_MESSAGE_LENGTH}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="contact-safer-gaming-message"
              placeholder={t("label_contact_safer_gaming_placeholder")}
              disabled={isSubmitting}
            />
          </StyledFormGroup>
          <StyledButton
            pub={skin === "pub"}
            selfexcludion
            onClick={handleSubmit}
            disabled={!canSubmit}
          >
            {isSubmitting ? t("label_loading") : t("label_submit")}
          </StyledButton>
        </StyledLimitWrapper>
      )}
    </ContactSaferGamingWrap>
  );
};

export default ContactSaferGaming;
